export default "{\n    \"FINDING_VENDOR\": \"Buscando proveedor\",\n    \"FINDING_QUOTE\": \"Buscando cotización\",\n    \"UNKNOWN\": \"Desconocido\"\n}"